module.exports = __webpack_public_path__ + "img/grocery-store.ac011c7b.svg";